export { default as ProductReviews } from './product-reviews'; 